<script>
import VCardEvents from "@/components/Events/VCardEvents.vue";

export default {
    name: "Events",
    components: {
        VCardEvents,
    },
    methods: {
    },
}
</script>

<template>
    <v-container fluid class="down-top-padding">
<!--        <v-row :no-gutters="false">
            <v-col>
                <v-card>
                    <v-card-title>Быстрый доступ...</v-card-title>
                    <v-card-subtitle>....</v-card-subtitle>
                    <v-card-text>
                        Тут вполне можно сохранить панель быстрого доступа.... И/или общефорумные настройки, если таковые у нас будут. Что, впрочем, маловероятно...
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>-->
        <v-row>
            <v-col>
                <!--
                <ajax-load
                    :url="$apiUrl.getForum($route.params)"
                    v-slot="{data, resolved}"
                >
                  <template v-if="resolved">
                    {{data.data.data.items[0].NAME_FULL.VALUE}}
                  </template>
                </ajax-load>
                -->
                <v-card-events
                    :url="$apiUrl.getForumEventsUrl($route.params)"
                    :item-avatar-size="100"
                ></v-card-events>
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped lang="scss">

</style>
